import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import ToastActions from '@store/toast/ToastActions';
import {List} from 'immutable';
import {Data, Int} from '@store/@types/util';
import {Store, StoreMethods} from '@store/@types/alt';
import {CreateToastInterface, Toast} from '@store/toast/Toast.types';

interface ToastStoreStateInterface {
  toasts: List<Toast>;
  toastCounter: Int;
}

class ToastStoreState extends Data<ToastStoreStateInterface>({
  toasts: List(),
  toastCounter: 0,
}) {}

@immutableStore
class ToastStore extends Store<ToastStoreState> implements StoreMethods<typeof ToastActions> {
  constructor() {
    super();
    this.state = new ToastStoreState();
    this.bindActions(ToastActions);
    this.exportPublicMethods({addToast: this.addToast.bind(this)});
  }

  addToast(toast: Partial<CreateToastInterface> & {message: string}) {
    const toastCounter = this.state.toastCounter + 1;
    this.setState({
      toastCounter,
      toasts: this.state.toasts.push(
        new Toast({
          ...toast,
          id: toastCounter,
        })
      ),
    });
    this.emitChange();
  }

  removeToast({id}: Toast) {
    this.setState({
      toasts: this.state.toasts.filter(toast => toast.id !== id),
    });
  }

  removeAllToasts(options = {dismissibleOnly: false}): void {
    const toasts: List<Toast> = options.dismissibleOnly
      ? this.state.toasts.filter(t => !t.dismissible)
      : List();
    this.setState({toasts});
  }
}

export default alt.createStore(ToastStore);
